import { useTranslation } from 'react-i18next';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { useQuery } from '@tanstack/react-query';
import { getDeployedGlobalRules, ListNamesDictionary } from 'Services';
import { RQ_DEPLOYED_GLOBAL_RULES } from 'Utils';
import { transformServerData } from '../helper';

type Props = {
    version?: number;
    simulationId?: string;
    enabled?: boolean;
    showDeletedRule?: boolean;
    listNameMap?: ListNamesDictionary;
    parameterData?: UseGetParametersResponse;
};

const useDeployedGlobalRules = ({
    version,
    simulationId,
    enabled,
    listNameMap,
    showDeletedRule,
    parameterData
}: Props) => {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_DEPLOYED_GLOBAL_RULES, templateRepositoryId],
        () => getDeployedGlobalRules(templateRepositoryId!, showDeletedRule, version, simulationId),
        {
            enabled: !!(templateRepositoryId && templateRepositoryId > 0) && enabled !== false,
            select: transformServerData({ t, listNameMap, parameterData })
        }
    );
};

export default useDeployedGlobalRules;
